import { Board } from '@/tracker/types';

import { BoardSettingsFormValues, NO_ESTIMATE } from '../types';

/** Доска → значения формы; null — новая доска */
export const toFormValues = (board: Board | null): BoardSettingsFormValues => ({
  name: board?.name ?? '',
  estimateBy: board?.estimateBy ?? NO_ESTIMATE,
  owner: board?.owner ?? null,
  columns: (board?.columns ?? []).map((column) => ({
    columnId: column.id,
    name: column.name,
    statuses: column.statuses.map((status) => status.key),
  })),
});
